import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { TravelReimbursementGridDataService } from 'common/services/data-services/student/travel-reimbursement/travel-grid-data.service';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';
import { TravelReimbursementGridMetaModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-grid-meta.model';
import { TravelReimbursementListingModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-grid.model';

 
@Injectable({
    providedIn: 'root'
})
export class TravelReimbursementGridWidgetService extends GridWidgetService<TravelReimbursementModel, TravelReimbursementListingModel> {
    constructor(protected override ds: TravelReimbursementGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new TravelReimbursementGridMetaModel().getMetaModel();
        return meta;
    }

}